import CardWrapper from 'hb-react/frontoffice/apps/Mentoring/components/SharedCard/CardWrapper';
import {
  type MentorProfileIndexCard,
  type Program,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { type MentorsCustomizableAttributes } from 'hb-react/frontoffice/apps/MyMentoring/utils/types';

import MentorButtons from './Buttons';

interface MentorCardProps {
  disabledAccess?: boolean;
  mentorCustomizableAttributes: MentorsCustomizableAttributes;
  mentorProfile: MentorProfileIndexCard;
  program: Program;
}

const MentorCard = ({
  program,
  mentorCustomizableAttributes,
  mentorProfile,
  disabledAccess,
}: MentorCardProps) => {
  const {
    config: {
      is_location_displayed_in_mentor_card: isLocationDisplayedInMentorCard,
      is_skills_displayed_in_mentor_card: isSkillsDisplayedInMentorCard,
    },
  } = program;

  return (
    <CardWrapper
      isSkillsDisplayed={isSkillsDisplayedInMentorCard}
      isLocationDisplayed={isLocationDisplayedInMentorCard}
      profile={mentorProfile}
      customAttributes={mentorCustomizableAttributes}
    >
      <MentorButtons
        mentorProfile={mentorProfile}
        program={program}
        disabledAccess={disabledAccess}
      />
    </CardWrapper>
  );
};

export default MentorCard;
